<template>
  <div @mousewheel="common.startNoopInterval" @click="common.startNoopInterval">
    <Header></Header>
    <!-- logo -->
    <div class="search">
      <div class="w search-box d-flex align-items-center">
        <div class="logo d-flex align-items-center">
          <router-link to="/"
            ><img
              class="img-default logo-img"
              :src="common_info.store.logo"
              alt
          /></router-link>
          <div class="shopconsed">结算</div>
        </div>
        <div class="search-c d-flex align-items-center">
          <div class="search-item search-item-active d-flex align-items-center">
            <div
              class="search-num search-num-active d-flex align-items-center justify-content-center"
            >
              1
            </div>
            我的购物车
          </div>
          <div class="search-line search-line-active"></div>
          <div class="search-item search-item-active d-flex align-items-center">
            <div
              class="search-num search-num-active d-flex align-items-center justify-content-center"
            >
              2
            </div>
            确认订单
          </div>
          <div class="search-line"></div>
          <div class="search-item d-flex align-items-center">
            <div
              class="search-num d-flex align-items-center justify-content-center"
            >
              3
            </div>
            付款
          </div>
          <div class="search-line"></div>
          <div class="search-item d-flex align-items-center">
            <div
              class="search-num d-flex align-items-center justify-content-center"
            >
              4
            </div>
            确认收货
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="w">
        <!-- 地址 -->
        <div class="address">
          <div class="address-top d-flex align-items-center">收货信息</div>
          <div class="address-list d-flex flex-wrap">
            <div
              class="address-item d-flex flex-direction-column justify-content-between"
              v-for="(item, index) in address_list"
              :key="index"
              :class="{ address_active: address_id == item.id }"
              @click="selectAddress(item.id)"
            >
              <div class="item-top d-flex align-items-center">
                <div
                  class="top-city flex_1"
                  :title="item.province + item.city + item.district"
                >
                  {{ item.province + item.city + item.district }}
                </div>
                <div class="top-name">({{ item.name }})</div>
                <div
                  class="top-btn d-flex align-items-center justify-content-center"
                  v-show="item.is_default == 1"
                >
                  默认
                </div>
              </div>
              <div class="address-conter">
                {{ item.detail }} {{ item.mobile }}
              </div>
              <div class="address-btn d-flex align-items-center">
                <div class="delete" @click.stop="deleteAddress(index)">
                  删除
                </div>
                <div class="amend" @click.stop="changeAddress(index)">修改</div>
                <div class="default" @click.stop="setUpDefault(index)">
                  设为默认
                </div>
              </div>
            </div>
            <div
              class="address-add d-flex align-items-center flex-direction-column justify-content-center"
              @click="addAddress()"
            >
              <div class="add-img">
                <img
                  class="img-default"
                  src="../../assets/images/adddress_add.png"
                  alt
                />
              </div>
              <div class="add-title">添加新地址</div>
            </div>
          </div>
        </div>
        <!-- 支付方式 -->
        <div class="pay" v-show="cash_on_delivery && pay_type_show">
          <div class="pay-title d-flex align-items-center">支付方式</div>
          <div class="pay-list d-flex flex-wrap">
            <!-- 后期需要修改 -->
            <!-- payitem.payment == 0 ||  -->
            <div
              class="pay-item d-flex align-items-center justify-content-center"
              v-if="
                payitem.payment == 0 ||
                payitem.payment == 1 ||
                payitem.payment == 5 ||
                (payitem.payment == 2 && offline_store == 0 && false)
              "
              v-for="(payitem, payindex) in data.pay_type_list"
              :key="payindex"
              :data-index="payindex"
              @click="checkPayType"
              :class="{ pay_active: payitem.checked }"
            >
              <div class="pay-img">
                <img class="img-default" :src="payitem.icon" alt />
              </div>
              <div class="pay-name">{{ payitem.name }}</div>
              <div class="pay-select" v-show="payitem.checked">
                <img
                  class="img-default"
                  src="../../assets/images/brand.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="submitshop">
          <div class="shop-name d-flex align-items-center">商品信息</div>
          <div class="shop-title d-flex align-items-center">
            <div class="shop-title-item" style="width: 35%">商品信息</div>
            <div
              class="shop-title-item d-flex justify-content-center"
              style="width: 14%"
            >
              规格
            </div>
            <div
              class="shop-title-item d-flex justify-content-center"
              style="width: 24%"
            >
              单价（元）
            </div>
            <div
              class="shop-title-item d-flex justify-content-center"
              style="width: 12%"
            >
              数量
            </div>
            <div
              class="shop-title-item d-flex justify-content-end"
              style="width: 15%"
            >
              小计（元）
            </div>
          </div>
          <div
            class="shop-store"
            v-for="(item, index) in goods_list"
            :key="index"
          >
            <div class="shore-name d-flex align-items-center">
              {{ item.name }}
              <div class="shore-img">
                <img class="img-default" :src="item.logo" alt />
              </div>
            </div>
            <div class="store-box">
              <!-- 普通商品 -->
              <div
                class="shop-item d-flex align-items-center"
                v-for="(itemGoods, goodindex) in item.goods_list"
                :key="goodindex"
              >
                <div
                  class="shop-details d-flex align-items-center"
                  style="width: 35%"
                >
                  <div class="shop-img">
                    <img
                      class="img-default"
                      :src="itemGoods.goods_pic"
                      alt
                      v-show="itemGoods.goods_pic"
                    />
                    <img
                      class="img-default"
                      src="../../assets/images/not_img.png"
                      alt
                      v-show="!itemGoods.goods_pic"
                    />
                  </div>
                  <div class="shop-names">{{ itemGoods.goods_name }}</div>
                </div>
                <div
                  class="shop-size d-flex justify-content-center"
                  style="width: 14%"
                >
                  <div class="shop-size-box">
                    <div
                      v-for="(itemAttr, indexAttr) in itemGoods.attr_list"
                      :key="indexAttr"
                    >
                      {{ itemAttr.attr_group_name }}：{{ itemAttr.attr_name }}
                    </div>
                  </div>
                </div>
                <div
                  class="shop-unpic d-flex justify-content-center"
                  style="width: 24%"
                >
                  ¥ {{ itemGoods.single_price }}
                </div>
                <div
                  class="shop-num d-flex justify-content-center"
                  style="width: 12%"
                >
                  {{ itemGoods.num }}
                </div>
                <div
                  class="shop-subtotal d-flex justify-content-end"
                  style="width: 15%"
                >
                  ¥{{ itemGoods.price }}
                </div>
              </div>
              <!-- 套餐 -->
              <!-- 后期需要修改 -->
              <div class="setmeal-box" v-show="false">
                <div class="setmeal-title d-flex align-items-center">
                  <div class="setmeal-name" style="width: 35%">
                    【套装】iPhone Xr套装10
                  </div>
                  <div style="width: 10%"></div>
                  <div
                    class="setmeal-unpic d-flex justify-content-center"
                    style="width: 28%"
                  >
                    ¥ 464.00
                  </div>
                  <div
                    class="setmeal-num d-flex justify-content-center"
                    style="width: 12%"
                  >
                    2
                  </div>
                  <div
                    class="setmeal-subtotal d-flex justify-content-end"
                    style="width: 15%"
                  >
                    ¥464.00
                  </div>
                </div>
                <div class="setmeal-list">
                  <div class="setmeal-item d-flex align-items-center">
                    <div
                      class="shop-details d-flex align-items-center"
                      style="width: 35%"
                    >
                      <div class="shop-img">
                        <img
                          class="img-default"
                          src="../../assets/images/goods_1.png"
                          alt
                        />
                      </div>
                      <div class="shop-names">
                        iDiskk苹果手机移动硬盘1TB iPhoneX
                        MFi认证可充电2.5英寸(一键
                      </div>
                    </div>
                    <div
                      class="shop-size d-flex justify-content-center"
                      style="width: 10%"
                    >
                      <div class="shop-size-box">
                        <div>尺码：XL</div>
                        <div>颜色：黑色</div>
                      </div>
                    </div>
                    <div style="width: 28%"></div>
                    <div
                      class="shop-num d-flex justify-content-center"
                      style="width: 12%"
                    >
                      1件/x1
                    </div>
                    <div style="width: 15%"></div>
                  </div>
                  <div class="setmeal-item d-flex align-items-center">
                    <div
                      class="shop-details d-flex align-items-center"
                      style="width: 35%"
                    >
                      <div class="shop-img">
                        <img
                          class="img-default"
                          src="../../assets/images/goods_1.png"
                          alt
                        />
                      </div>
                      <div class="shop-names">
                        iDiskk苹果手机移动硬盘1TB iPhoneX
                        MFi认证可充电2.5英寸(一键
                      </div>
                    </div>
                    <div
                      class="shop-size d-flex justify-content-center"
                      style="width: 10%"
                    >
                      <div class="shop-size-box">
                        <div>尺码：XL</div>
                        <div>颜色：黑色</div>
                      </div>
                    </div>
                    <div style="width: 28%"></div>
                    <div
                      class="shop-num d-flex justify-content-center"
                      style="width: 12%"
                    >
                      1件/x1
                    </div>
                    <div style="width: 15%"></div>
                  </div>
                </div>
              </div>
              <div class="shop-rest d-flex flex-wrap">
                <div class="rest-top" v-if="item.is_invoice">
                  <!-- 发票 -->
                  <div class="invoice">
                    <div
                      class="invoice-title d-flex align-items-start"
                      @click="isInvoice(index)"
                    >
                      <div class="invoice-select">
                        <img
                          class="img-default"
                          src="../../assets/images/select_checked.png"
                          alt
                          v-show="item.is_show_invoice"
                        />
                        <img
                          class="img-default"
                          src="../../assets/images/select_unchecked.png"
                          alt
                          v-show="!item.is_show_invoice"
                        />
                      </div>
                      开具发票
                    </div>
                    <div class="invoice-content" v-show="item.is_show_invoice">
                      <div class="tab-list d-flex flex-wrap">
                        <div
                          class="tab-item d-flex align-items-center"
                          v-for="(invoiceItem, invoiceIndex) in invoice_list"
                          @click="selectInvoice(index, invoiceIndex)"
                          :class="{
                            invoice_active:
                              item.checked_invoice_index == invoiceIndex,
                          }"
                        >
                          <div
                            class="tab-img d-flex align-items-center justify-content-center"
                            v-show="invoiceItem.type == 1"
                          >
                            个
                          </div>
                          <div
                            class="tab-img d-flex align-items-center justify-content-center"
                            v-show="invoiceItem.type == 2"
                          >
                            企
                          </div>
                          <div>{{ invoiceItem.header }}</div>
                          <div
                            class="tab-select"
                            v-show="item.checked_invoice_index == invoiceIndex"
                          >
                            <img
                              class="img-default"
                              src="../../assets/images/brand.png"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div class="invoice-type d-flex align-items-center">
                        <div class="invoice-type-name">发票类型</div>
                        <el-select
                          v-model="item.choice_invoice_id"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="invoiceTypeItem in item.invoice_type_list"
                            :key="invoiceTypeItem.id"
                            :label="invoiceTypeItem.name"
                            :value="invoiceTypeItem.id"
                            v-show="invoiceTypeItem.id == 1"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="invoice-radio d-flex align-items-center">
                        <div class="invoice-type-name">抬头类型</div>
                        <div class="invoice-radio-box">
                          <el-radio
                            v-model="item.invoice_title_type"
                            label="1"
                            @change="changeInvoiceTitle(index)"
                            >个人或事业单位</el-radio
                          >
                          <el-radio
                            v-model="item.invoice_title_type"
                            label="2"
                            @change="changeInvoiceTitle(index)"
                            >企业</el-radio
                          >
                        </div>
                      </div>
                      <div class="invoice-hearder d-flex align-items-center">
                        <div class="invoice-type-name">发票抬头</div>
                        <el-input
                          v-model="item.invoice_title"
                          placeholder="填写抬头名称"
                          @keyup.native="invoiceTxt(index)"
                        ></el-input>
                      </div>
                      <div
                        class="invoice-hearder d-flex align-items-center"
                        v-show="item.invoice_title_type == 2"
                      >
                        <div class="invoice-type-name">税号</div>
                        <el-input
                          v-model="item.invoice_taxpayer"
                          placeholder="纳税人识别号或社会统一征信代码"
                          @keyup.native="invoiceTxt(index)"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rest-top" v-if="!vr_type || vr_type == 0">
                  <!-- 配送方式 -->
                  <div class="send">
                    <div class="send-title d-flex align-items-start">
                      配送方式
                    </div>
                    <div class="send-list d-flex" v-show="item.mch_id == 0">
                      <!-- 后期需要修改 -->
                      <div
                        class="send-item d-flex align-items-center justify-content-center"
                        v-for="(methodItem, methodIndex) in shopping_method"
                        v-show="item.send_type == 0 && methodIndex == 0"
                        @click="shoppingMethod(methodIndex)"
                        :class="{
                          send_active: shopping_method_index == methodIndex,
                        }"
                      >
                        <div>{{ methodItem }}</div>
                        <div
                          class="send-select"
                          v-show="shopping_method_index == methodIndex"
                        >
                          <img
                            class="img-default"
                            src="../../assets/images/brand.png"
                            alt
                          />
                        </div>
                      </div>
                      <div
                        class="send-item d-flex align-items-center justify-content-center send_active"
                        v-show="item.send_type == 1"
                      >
                        <div>快递配送</div>
                        <div class="send-select">
                          <img
                            class="img-default"
                            src="../../assets/images/brand.png"
                            alt
                          />
                        </div>
                      </div>
                      <!-- 后期需要修改 -->
                      <div
                        class="send-item d-flex align-items-center justify-content-center send_active"
                        v-show="item.send_type == 2 && false"
                      >
                        <div>到店自提</div>
                        <div class="send-select">
                          <img
                            class="img-default"
                            src="../../assets/images/brand.png"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                    <div class="send-list d-flex" v-show="item.mch_id != 0">
                      <div
                        class="send-item d-flex align-items-center justify-content-center send_active"
                      >
                        <div>快递配送</div>
                        <div class="send-select">
                          <img
                            class="img-default"
                            src="../../assets/images/brand.png"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="send-box"
                      v-if="
                        (item.send_type == 0 && shopping_method_index == 1) ||
                        item.send_type == 2
                      "
                    >
                      <div class="send-box-item">
                        自提站：北京大厦
                        <span @click="shopVisible = true">修改</span>
                      </div>
                      <div class="send-box-item">电话：18500390499</div>
                      <div class="send-box-item">
                        自提地点：福盈家园3号院人防西侧丰巢智能柜
                      </div>
                    </div>
                    <div class="send-pic" v-else>
                      <div v-show="address_id">
                        运费：￥{{ item.express_price }}
                      </div>
                      <div v-show="!address_id">请先选择收货地址</div>
                    </div>
                  </div>
                </div>
                <!-- 后期需要修改 -->
                <div
                  class="rest-top"
                  v-if="
                    goods_list[store_index].coupon_list &&
                    goods_list[store_index].coupon_list.length
                  "
                >
                  <!-- 优惠券 -->
                  <div class="coupon">
                    <div
                      class="coupon-title d-flex align-items-start"
                      @click="couponShow(index, store_index)"
                    >
                      <div class="coupon-select">
                        <img
                          class="img-default"
                          src="../../assets/images/select_checked.png"
                          alt
                          v-show="coupon_show"
                        />
                        <img
                          class="img-default"
                          src="../../assets/images/select_unchecked.png"
                          alt
                          v-show="!coupon_show"
                        />
                      </div>
                      优惠券 ({{ goods_list[index].coupon_list.length }})
                    </div>
                    <div class="coupon-box" v-show="coupon_show">
                      <!-- <div class="coupon-tab d-flex">
												<div class="tab-item d-flex align-items-center justify-content-center" @click="selectCoupon(0)" :class="{coupon_active:couponIndex==0}">可用优惠券</div>
												<div class="tab-item d-flex align-items-center justify-content-center" @click="selectCoupon(1)" :class="{coupon_active:couponIndex==1}">不可用优惠券</div>
											</div> -->
                      <div class="coupon-list">
                        <el-radio
                          v-model="radio"
                          :label="its.user_coupon_id"
                          @change="checkCoupon(its, idx, store_index)"
                          v-for="(its, idx) in goods_list[store_index]
                            .coupon_list"
                          :key="idx"
                        >
                          <div
                            class="list-item d-flex align-items-center justify-content-between"
                          >
                            <div class="item-pic">
                              <span>￥</span> {{ its.sub_price }}
                            </div>
                            <div>满{{ its.min_price }}元使用</div>
                            <!-- <div>限美妆品类部分商品</div> -->
                            <div>
                              有效期: {{ its.begin_time }}-{{ its.end_time }}
                            </div>
                          </div>
                        </el-radio>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rest-top">
                  <div class="leave">
                    <div class="leave-title d-flex align-items-start">
                      给卖家留言：
                    </div>
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="请输入内容"
                      v-model="item.content"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 虚拟商品邮箱 -->
        <div class="mailbox-box clearfloat" v-show="vr_type && vr_type != 0">
          <div class="title">邮箱账号：</div>
          <input
            type="text"
            placeholder="请填写邮箱方便发送到邮箱"
            v-model="mailbox_val"
          />
        </div>
        <!-- 结算信息 -->
        <div class="close">
          <div class="close-title">结算信息</div>
          <div class="close-box">
            <!-- 积分 -->
            <div
              class="integral d-flex align-items-center integraled"
              v-if="false"
            >
              <el-switch
                v-model="integral_status"
                active-color="#CCCCCC"
                inactive-color="#FF0E25"
              ></el-switch>
              <div class="integral-title">
                使用2000积分抵扣
                <span>2</span> 元
              </div>
            </div>
            <!-- 消费卡 -->
            <div class="expense" v-if="false">
              <div class="expense-top d-flex align-items-center">
                <div class="expense-img">
                  <img
                    class="img-default"
                    src="../../assets/images/select_checked.png"
                    alt
                  />
                </div>
                <div class="expense-title">消费卡支付</div>
              </div>
              <div class="expense-box">
                <div class="expense-tab d-flex">
                  <div
                    class="tab-item d-flex align-items-center justify-content-center"
                    @click="selectCoupon(0)"
                    :class="{ coupon_active: couponIndex == 0 }"
                  >
                    可用消费卡
                  </div>
                  <div
                    class="tab-item d-flex align-items-center justify-content-center"
                    @click="selectCoupon(1)"
                    :class="{ coupon_active: couponIndex == 1 }"
                  >
                    不可用消费卡
                  </div>
                  <div
                    class="tab-item d-flex align-items-center justify-content-center"
                    @click="selectCoupon(2)"
                    :class="{ coupon_active: couponIndex == 2 }"
                  >
                    添加礼品卡
                  </div>
                </div>
                <div class="expense-list">
                  <div
                    class="list-item d-flex align-items-center justify-content-between"
                  >
                    <div class="item-pic"><span>￥</span> 10</div>
                    <div>面值：¥800</div>
                    <div>卡号：8374759GR38594</div>
                    <div>有效期至 2020-10-23</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 余额 -->
            <div
              class="integral d-flex align-items-center"
              v-if="balance_pay && user_info.money > 0 && balance_is_show"
            >
              <el-switch
                v-model="balance_status"
                active-color="#FF0E25"
                inactive-color="#CCCCCC"
                @change="balanceChange"
              ></el-switch>
              <div class="integral-title">
                余额支付(
                <span>¥{{ balance_price || user_info.money }}</span
                >)
              </div>
            </div>
            <!-- 总计 -->
            <div class="aggregate d-flex justify-content-end">
              <div
                class="aggregate-l d-flex flex-direction-column align-items-end"
              >
                <div class="aggregate-l-item">
                  <span>{{ order_goods_num }}</span
                  >件商品 总计：
                </div>
                <div class="aggregate-l-item">运费：</div>
                <!-- <div class="aggregate-l-item">优惠：</div> -->
                <!-- <div class="aggregate-l-item">优惠券/卡：</div> -->
              </div>
              <div class="aggregate-r">
                <div class="aggregate-r-item">
                  ¥{{ order_total_goods_price }}
                </div>
                <div class="aggregate-r-item">¥{{ all_express_price }}</div>
                <!-- <div class="aggregate-r-item">-¥0.00</div> -->
                <!-- <div class="aggregate-r-item">-¥0.00</div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 底部提交 -->
        <div class="bottom d-flex flex-direction-column align-items-end">
          <div class="bottom-pic">
            应付金额：
            <span>¥{{ order_total_price }}</span>
          </div>
          <template
            v-for="(item, index) in address_list"
            v-if="address_id == item.id"
          >
            <div class="bottom-address">
              <span>寄送至：</span>{{ item.city }} {{ item.district }}
              {{ item.detail }}
            </div>
            <div class="bottom-person">
              <span>收货人：</span>{{ item.name }} {{ item.mobile }}
            </div>
          </template>
          <div
            class="bottom-btn d-flex align-items-center justify-content-center"
            @click="payNow"
          >
            提交订单
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址弹窗 -->
    <div class="address-mask">
      <el-dialog title="新增收货信息" :visible.sync="addressVisible">
        <div class="address-mask-box d-flex justify-content-center">
          <div
            class="address-mask-l d-flex flex-direction-column align-items-end"
          >
            <div class="item-title">收货人：</div>
            <div class="item-title">手机：</div>
            <div class="item-title">所在地区：</div>
            <div class="item-title">详细地址：</div>
          </div>
          <div class="address-mask-r d-flex flex-direction-column">
            <el-input
              class="item-input"
              v-model="address_name"
              placeholder="姓名，如张航"
            ></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_name_type">
                <div class="hint-img">
                  <img
                    class="img-default"
                    src="../../assets/images/hint_icon.png"
                    alt
                  />
                </div>
                收货人名称最少2位
              </template>
            </div>
            <el-input
              v-model="address_mobile"
              placeholder="请填写正确的11位手机号码"
              maxlength="11"
            ></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_mobile_type">
                <div class="hint-img">
                  <img
                    class="img-default"
                    src="../../assets/images/hint_icon.png"
                    alt
                  />
                </div>
                请填写正确的手机号
              </template>
            </div>
            <el-cascader
              :options="district_list"
              :props="{ value: 'id', label: 'name', children: 'list' }"
              v-model="address_province"
              @change="provinceChange"
            ></el-cascader>
            <div class="hint d-flex align-items-center">
              <template v-if="address_province_type">
                <div class="hint-img">
                  <img
                    class="img-default"
                    src="../../assets/images/hint_icon.png"
                    alt
                  />
                </div>
                请选择地区
              </template>
            </div>
            <el-input
              v-model="address_detail"
              placeholder="街道、小区、楼牌号等"
            ></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_detail_type">
                <div class="hint-img">
                  <img
                    class="img-default"
                    src="../../assets/images/hint_icon.png"
                    alt
                  />
                </div>
                请填写详细地址
              </template>
            </div>
            <div
              class="default d-flex align-items-center"
              @click="change_default"
            >
              <div class="default-img">
                <img
                  class="img-default"
                  src="../../assets/images/select_checked.png"
                  alt
                  v-show="address_is_default"
                />
                <img
                  class="img-default"
                  src="../../assets/images/select_unchecked.png"
                  alt
                  v-show="!address_is_default"
                />
              </div>
              设为默认收货地址
            </div>
            <div
              class="address-btn d-flex align-items-center justify-content-center"
              @click="preserveAddress()"
            >
              保存并使用
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 门店弹窗 -->
    <div class="shop-mask">
      <el-dialog title="选择自提点" :visible.sync="shopVisible">
        <!-- 顶部流程 -->
        <div class="flow d-flex align-items-center">
          <div class="flow-item d-flex align-items-center">
            <div
              class="flow-num d-flex align-items-center justify-content-center"
            >
              1
            </div>
            选择代售点并下单
          </div>
          <div class="flow-img">
            <img class="img-default" src="../../assets/images/rigth.png" alt />
          </div>
          <div class="flow-item d-flex align-items-center">
            <div
              class="flow-num d-flex align-items-center justify-content-center"
            >
              2
            </div>
            收到提货信息（或物流详情）
          </div>
          <div class="flow-img">
            <img class="img-default" src="../../assets/images/rigth.png" alt />
          </div>
          <div class="flow-item d-flex align-items-center">
            <div
              class="flow-num d-flex align-items-center justify-content-center"
            >
              3
            </div>
            到菜鸟驿站自提
          </div>
        </div>
        <!-- 选择地址/店名 -->
        <div class="select-store d-flex align-items-center">
          <el-cascader
            v-model="value"
            :options="district_list"
            @change="handleChange"
          ></el-cascader>
          <input
            class="store-input"
            placeholder="请输入地址或店名"
            type="text"
          />
          <div
            class="store-search d-flex align-items-center justify-content-center"
          >
            搜索
          </div>
        </div>
        <div class="store-box d-flex justify-content-between">
          <div class="store-list">
            <div class="store-item" v-for="item in 10" :key="item">
              <div class="item-top d-flex align-items-center">
                <div class="item-img">
                  <img
                    class="img-default"
                    src="../../assets/images/select_unchecked.png"
                    alt
                  />
                </div>
                <div class="item-name">福盈家园3号院人防西侧丰巢智能柜</div>
                <div class="item-distance">1.3KM</div>
              </div>
              <div class="item-tel">电话：19888325566</div>
              <div class="item-address">
                地址：北京市北京市朝阳区三间房街道三间房西路3号院
              </div>
            </div>
          </div>
          <div class="map"></div>
        </div>
        <div class="store-btn d-flex">
          <div class="confirm d-flex align-items-center justify-content-center">
            确定
          </div>
          <div class="cancel d-flex align-items-center justify-content-center">
            取消
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 支付弹层 -->
    <div class="ttshop_pay">
      <el-dialog
        title=""
        :visible.sync="pay_cont_type"
        :before-close="payContTypeChange"
      >
        <div class="pay-title d-flex align-items-center justify-content-center">
          微信支付￥{{ order_total_price }}
        </div>
        <div
          class="pay-qrcode d-flex align-items-center justify-content-center"
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>

    <!-- 宝付支付弹窗 -->
    <div class="ttshop_pay">
      <el-dialog
        title=""
        :visible.sync="baofu_pay_cont_type"
        :before-close="payContTypeChange"
      >
        <div class="pay-title d-flex align-items-center justify-content-center">
          {{ payType }}￥{{ order_total_price }}
        </div>
        <img class="pay-qrcode" :src="baofu_pay_code_url" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import QRCode from "qrcodejs2";
import "./submitOrder.css";
let Base64 = require("js-base64").Base64;
export default {
  components: {
    Header,
  },
  data() {
    return {
      common_info: {
        store: {},
      },
      mch_list: this.$store.state.submit_order_rarams.mch_list,
      vr_type: this.$store.state.submit_order_rarams.vr_type,
      addressVisible: false, // 地址弹框
      shopVisible: false,
      couponIndex: 0,
      value: "",
      address_id: "", // 选中地址id
      address_list: [], // 地址列表
      address_name: "", // 地址-用户名
      address_name_type: false,
      address_mobile: "", // 地址-手机号
      address_mobile_type: false,
      address_province: [], // 地址-省市区
      address_province_type: false,
      address_detail: "", // 地址-详细地址
      address_detail_type: false,
      address_is_default: 0, // 地址-是否设为默认地址
      district_list: [], // 地址省市区列表
      need_save_address_id: "", // 需要修改的地址id
      data: {
        pay_type_list: [{}],
        integral: {
          forehead: 0,
        },
        coupon_list: [],
        shop_list: [],
      },
      offline_store: "",
      platform_index: 0,
      payment_type: -1,
      goods_list: [],
      balance_status: false, //余额开关状态
      integral_status: false,
      expense_card_inx: 0,
      expense_card_number: "", //消费卡账号
      expense_card_password: "", //消费卡密码
      cash_on_delivery: true, //货到付款状态
      balance_pay: false,
      pay_type_show: true,
      shopping_method: ["快递配送", "到店自提"],
      shopping_method_index: 0,
      invoice_list: [], //发票抬头列表
      balance_price: "", //剩余余额
      user_info: {},
      balance_is_show: true,
      order_goods_num: 0, //订单商品数量
      order_total_price: 0, //总价应付金额
      order_total_goods_price: 0, //商品总金额（裸价）
      integral_is_show: true,
      expense_card_is_show: true,
      use_expense_card_price: "",
      mailbox_val: "", // 虚拟卡密商品邮箱
      expense_card_show: false,
      add_expense_card_show: false,
      consumer_card: "",
      consumer_card_usable: "",
      consumer_card_not_usable: "",
      coupon_show: false,
      store_index: 0,
      store_show: false,
      use_consumer: "", // 消费卡使用
      check_expense_card: "",
      all_express_price: "", //总运费
      pay_cont_type: false, //支付二维码弹层
      order_status_query: "", //查询订单状态计时器
      loading: "",
      store: {
        store: {},
      }, //商城配置，用户信息，热搜
      radio: "", //为选择优惠券那下标
      alipayIsZl: 1, //是否为支付宝直接支付 1：不是 2：是
      wechatIsZl: 1, //是否为微信直接支付 1：不是 2：是
      baofu_pay_cont_type: false, //宝付支付二维码弹层
      baofu_pay_code_url: "", //宝付支付二维码
      payType: "微信支付", //宝付支付类型
      dataTrackingParams: {
        scene: "结算页",
        type: 1,
      }, //埋点页面传参
    };
  },
  created() {
    let that = this;
    if (sessionStorage.getItem("alipay_type")) {
      that
        .$confirm("订单已提交,请到订单中心查看", "温馨提示", {
          confirmButtonText: "查看订单",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.$router.replace({
            path: "/ttshop_usermyorder",
            query: {},
          });
        })
        .catch(() => {
          that.$router.replace({
            path: "/ttshop_usermyorder",
            query: {},
          });
        });
    }
    this.getData();
    this.getAddressList();
    this.getDistrict();
    this.getUserInfo();
    this.common.getCommonInfo(this);
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(that.order_status_query);
  },
  methods: {
    checkCoupon(item, coupon_index, store_index) {
      // console.log(id);
      this.radio =
        this.goods_list[store_index].coupon_list[coupon_index].user_coupon_id;
      this.computePrice();
    },
    //优惠券展示/隐藏
    couponShow(index, store_index) {
      let that = this;
      (that.coupon_show = !that.coupon_show), (that.store_index = index);

      //   console.log(this.radio)
      this.computePrice();
      //
    },
    // 获取用户信息
    getUserInfo() {
      let that = this;
      this.$api
        .userIndex()
        .then((res) => {
          if (res.code == 0) {
            that.user_info = res.data.user;
            that.computePrice();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取数据
    getData() {
      let that = this;
      let params = {
        mch_list: that.mch_list,
      };
      let payment_type = -1; // 支付方式
      if (that.address_id) {
        params.address_id = that.address_id;
      }
      /* if (that.address_str) {
					params.longitude = that.address_str.longitude;
					params.latitude = that.address_str.latitude;
				} */
      this.$api
        .submitPreview(params)
        .then((res) => {
          if (res.code == 0) {
            /* let consumer_card = res.data.consumer_card; //消费卡
						let consumer_card_usable = 0;
						let consumer_card_not_usable = 0; */
            let platform_index = -1;
            let offline_store = 0; //店铺配送方式
            /* if (consumer_card.length > 0) {
							for (let i in consumer_card) {
								consumer_card[i].end_time = appUtils.tips.timestampToTime(consumer_card[i].end_time);
								if (consumer_card[i].status == 0) {
									consumer_card_usable++;
								} else {
									consumer_card_not_usable++;
								}
							}
						} */

            let goods_list = that.goods_list;
            for (let i in res.data.mch_list) {
              if (res.data.mch_list[i].mch_id == 0) {
                platform_index = i;
                for (let j in res.data.mch_list[i].shop_list) {
                  if (res.data.mch_list[i].shop_list[j].is_default == 1) {
                    res.data.mch_list[i].shop =
                      res.data.mch_list[i].shop_list[j];
                  }
                }
              }
              if (goods_list.length <= 0) {
                if (res.data.mch_list[i].send_type == 2) {
                  res.data.mch_list[i].offline = 1;
                  offline_store = 1;
                } else {
                  res.data.mch_list[i].offline = 0;
                }
              }
              res.data.mch_list[i].source = 4; //来源
              res.data.mch_list[i].invoice_title_type = "1"; //发票抬头类型

              // res.data.mch_list[i].invoice_type_list = []; //发票类型列表
              // res.data.mch_list[i].is_show_invoice = false; //是否开发票
              // res.data.mch_list[i].choice_invoice_id = ''; //发票类型id
              // res.data.mch_list[i].checked_invoice_index = -1; //选择的发票抬头下标
              // res.data.mch_list[i].invoice_title = ''; //发票抬头
              // res.data.mch_list[i].invoice_taxpayer = ''; //税号
              // res.data.mch_list[i].invoice_id = ''; //选择的发票抬头id
            }
            for (let i in res.data.pay_type_list) {
              res.data.pay_type_list[i].checked = false;
              if (res.data.pay_type_list.length == 1) {
                res.data.pay_type_list[i].checked = true;
                payment_type = res.data.pay_type_list[i].payment;
                // 判断到店自提和货到付款同时存在
                if (
                  offline_store == 1 &&
                  res.data.pay_type_list[i].payment == 2
                ) {
                  res.data.pay_type_list[i].checked = false;
                  payment_type = -1;
                }
                if (res.data.pay_type_list[i].payment == 3) {
                  that.balance_status = 1;
                }
              }
              // 默认支付方式
              if (res.data.pay_type_list[i].payment == 0) {
                res.data.pay_type_list[i].checked = true;
                payment_type = res.data.pay_type_list[i].payment;
              } else if (res.data.pay_type_list[i].payment == 2) {
                //货到付款开启
                that.cash_on_delivery = true;
              } else if (res.data.pay_type_list[i].payment == 3) {
                //余额支付开启
                that.balance_pay = true;
              }
            }
            if (goods_list.length > 0) {
              for (let i in goods_list) {
                goods_list[i] = {
                  ...goods_list[i],
                  ...res.data.mch_list[i],
                };
              }
            } else {
              goods_list = res.data.mch_list;
            }
            that.data = res.data;
            that.offline_store = offline_store;
            that.platform_index = platform_index;
            that.goods_list = goods_list;
            console.log(that.goods_list);
            // 待修改
            for (let i in goods_list) {
              that.$set(that.goods_list, i, goods_list[i]);
            }
            // that.consumer_card = consumer_card;
            // that.consumer_card_usable = consumer_card_usable;
            // that.consumer_card_not_usable = consumer_card_not_usable;
            that.payment_type = payment_type;
            that.alipayIsZl = res.data.alipay_is_zl;
            that.wechatIsZl = res.data.wetchat_is_zl;
            that.computePrice();
          }
        })
        .catch((err) => {
          console.log(err);
          that.$message.error(err.msg);
          setTimeout(() => {
            that.$router.go(-1);
          }, 800);
        });
    },
    // 选择支付方式
    checkPayType(e) {
      let that = this;
      let index = e.currentTarget.dataset.index;
      let data = that.data;
      let goods_list = that.goods_list;
      for (let i in that.data.pay_type_list) {
        that.data.pay_type_list[i].checked = false;
      }
      data.pay_type_list[index].checked = true;
      console.log(data.pay_type_list);
      if (data.pay_type_list[index].payment == 2) {
        //货到付款
        for (let i in goods_list) {
          goods_list[i].picker_coupon = "";
        }
        that.integral_status = 0;
        that.balance_status = 0;
        that.goods_list = goods_list;
        that.use_consumer = "";
        that.check_expense_card = "";
        that.computePrice();
      }
      that.data = data;
      that.payment_type = data.pay_type_list[index].payment;
    },
    // 是否开发票
    isInvoice(index) {
      let goods_list = this.goods_list;
      let choice_invoice = goods_list[index].choice_invoice;
      let invoice_type_list = [];
      for (let i in choice_invoice) {
        if (choice_invoice[i] == 1) {
          invoice_type_list.push({
            id: 1,
            name: "普通发票",
          });
        } else if (choice_invoice[i] == 2) {
          invoice_type_list.push({
            id: 2,
            name: "增值税专用发票",
          });
        }
      }
      this.$set(goods_list[index], "invoice_type_list", invoice_type_list); // 发票类型列表
      if (goods_list[index].is_show_invoice) {
        this.$set(goods_list[index], "is_show_invoice", false); // 是否开发票
        this.$set(goods_list[index], "choice_invoice_id", ""); // 选择的发票类型id
        this.$set(goods_list[index], "invoice_id", ""); // 选择的发票类型id
      } else {
        this.$set(goods_list[index], "is_show_invoice", true); // 是否开发票
        this.$set(goods_list[index], "choice_invoice_id", 1); // 选择的发票类型id
      }
      if (this.invoice_list.length == 0) {
        this.getInvoiceList();
      }
      this.goods_list = goods_list;
    },
    // 获取已有发票抬头列表
    getInvoiceList() {
      let that = this;
      this.$api
        .invoiceList()
        .then((res) => {
          if (res.code == 0) {
            that.invoice_list = res.data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 已有发票抬头选择
    selectInvoice(index, invoice_index) {
      let goods_list = this.goods_list;
      let invoice_list = this.invoice_list;
      this.$set(goods_list[index], "checked_invoice_index", invoice_index); //选择发票抬头下标
      this.$set(
        goods_list[index],
        "invoice_title_type",
        invoice_list[invoice_index].type
      ); //发票抬头类型
      this.$set(
        goods_list[index],
        "invoice_title",
        invoice_list[invoice_index].header
      ); //发票抬头
      this.$set(
        goods_list[index],
        "invoice_taxpayer",
        invoice_list[invoice_index].taxpayer
      ); //税号
      this.$set(
        goods_list[index],
        "invoice_id",
        invoice_list[invoice_index].id
      ); //发票抬头id
      this.goods_list = goods_list;
    },
    // 发票抬头切换
    changeInvoiceTitle(index) {
      let goods_list = this.goods_list;
      this.$set(goods_list[index], "checked_invoice_index", -1); //选择发票抬头下标
      this.$set(goods_list[index], "invoice_id", ""); //发票抬头id
      this.goods_list = goods_list;
    },
    // 发票信息发生变动触发
    invoiceTxt(index) {
      let goods_list = this.goods_list;
      this.$set(goods_list[index], "checked_invoice_index", -1); //选择发票抬头下标
      this.$set(goods_list[index], "invoice_id", ""); //发票抬头id
      this.goods_list = goods_list;
    },
    // 配送方式
    shoppingMethod(index) {
      // this.shopping_method_index = index;
      let goods_list = this.goods_list;
      goods_list[this.platform_index].offline = index;
      this.goods_list = goods_list;
      this.shopping_method_index = index;
      this.offline_store = index;
      // 判断如果是到店自提取消货到付款的选项
      if (index == 1) {
        let that = this;
        let pay_type_list = that.data.pay_type_list;
        let payment_type = that.payment_type;
        for (let i in pay_type_list) {
          if (pay_type_list[i].checked && pay_type_list[i].payment == 2) {
            pay_type_list[i].checked = false;
            payment_type = -1;
          }
        }
        that.data.pay_type_list = pay_type_list;
        that.data = that.data;
        that.payment_type = payment_type;
      }
      this.computePrice();
    },
    // 余额开关
    balanceChange() {
      this.computePrice();
      this.payTypeChecking();
    },
    payTypeChecking() {
      let that = this;
      if (that.order_total_price <= 0) {
        let pay_type_list = that.data.pay_type_list;
        for (let i in pay_type_list) {
          pay_type_list[i].checked = false;
        }
        that.data.pay_type_list = pay_type_list;
        that.payment_type = 3;
        that.pay_type_show = false;
        that.data = that.data;
      } else {
        let payment_type = -1;
        let type = false;
        let pay_type_list = that.data.pay_type_list;

        for (let i in pay_type_list) {
          if (pay_type_list[i].checked) {
            type = true;
            payment_type = pay_type_list[i].payment;
          }
        }
        if (!type) {
          for (let i in pay_type_list) {
            if (pay_type_list[i].payment == 1) {
              pay_type_list[i].checked = true;
              payment_type = 1;
            }
          }
        }
        that.data.pay_type_list = pay_type_list;
        that.payment_type = payment_type;
        that.pay_type_show = true;
        that.data = that.data;
      }
    },
    //优惠券选择
    selectCoupon(index) {
      this.couponIndex = index;
    },
    handleChange(value) {
      console.log(value);
    },
    // 获取地址列表
    getAddressList() {
      let that = this;
      this.$api
        .addressList()
        .then((res) => {
          if (res.code == 0) {
            let list = res.data.list;
            that.checkedAddress(list);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 地址默认选中
    checkedAddress(list) {
      let type = false;
      let that = this;
      if (list && list.length) {
        for (let i in list) {
          if (list[i].is_default == 1) {
            that.address_id = list[i].id;
            type = true;
          }
        }
        if (!type) {
          that.address_id = list[0].id;
        }
        that.address_list = list;
      } else {
        that.address_id = "";
      }
      // this.getData();
    },
    // 获取省市区
    getDistrict() {
      let that = this;
      this.$api
        .district()
        .then((res) => {
          if (res.code == 0) {
            that.district_list = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 新增收货地址
    addAddress() {
      this.addressVisible = true;
      this.address_name = "";
      this.address_mobile = "";
      this.address_province = [];
      this.address_detail = "";
      this.address_is_default = 0;
    },
    // 保存地址
    preserveAddress() {
      let that = this;
      let address_name = this.address_name.trim();
      let address_mobile = this.address_mobile.trim();
      let address_province = this.address_province;
      let address_detail = this.address_detail.trim();
      this.address_name_type = false;
      this.address_mobile_type = false;
      this.address_province_type = false;
      this.address_detail_type = false;
      if (address_name.length < 2) {
        this.address_name_type = true;
        return false;
      } else if (!/^1[3456789]\d{9}$/.test(address_mobile)) {
        this.address_mobile_type = true;
        return false;
      } else if (!address_province.length) {
        this.address_province_type = true;
        return false;
      } else if (!address_detail) {
        this.address_detail_type = true;
        return false;
      }
      let params = {
        name: address_name,
        mobile: address_mobile,
        detail: address_detail,
        lng: "0",
        lat: "0",
        province_id: address_province[0],
        city_id: address_province[1],
        district_id: address_province[2],
        is_default: this.address_is_default,
      };
      if (this.need_save_address_id) {
        params.address_id = this.need_save_address_id;
      }
      this.$api
        .addressSave(params)
        .then((res) => {
          if (res.code == 0) {
            if (that.need_save_address_id) {
              that.need_save_address_id = "";
              that.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
            } else {
              that.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
            }
            that.getAddressList();
            that.addressVisible = false;
            that.address_name = "";
            that.address_mobile = "";
            that.address_province = [];
            that.address_detail = "";
            that.address_is_default = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改地址
    changeAddress(index) {
      let that = this;
      let address = this.address_list[index];
      this.address_name = address.name;
      this.address_mobile = address.mobile;
      this.address_province = [
        Number(address.province_id),
        Number(address.city_id),
        Number(address.district_id),
      ];
      this.address_detail = address.detail;
      this.address_is_default = Number(address.is_default);
      this.need_save_address_id = address.id;
      this.addressVisible = true;
    },
    // 设为默认
    setUpDefault(index) {
      let that = this;
      let is_default = this.address_list[index].is_default;
      let params = {
        address_id: this.address_list[index].id,
      };
      if (is_default != 1) {
        this.$api
          .addressDefault(params)
          .then((res) => {
            if (res.code == 0) {
              that.getAddressList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 删除地址
    deleteAddress(index) {
      let that = this;
      let params = {
        address_id: this.address_list[index].id,
      };
      this.$confirm("确认删除当前地址吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          that.$api
            .addressDelete(params)
            .then((res) => {
              if (res.code == 0) {
                that.address_list.splice(index, 1);
                that.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                  offset: 200,
                  duration: 1000,
                });
                let list = that.address_list;
                that.checkedAddress(list);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    // 选择省市区
    provinceChange(value) {
      // console.log(value);
    },
    change_default() {
      this.address_is_default = this.address_is_default == 0 ? 1 : 0;
    },
    // 地址选择
    selectAddress(id) {
      this.address_id = id;
      this.getData();
    },
    addInvoice(index, callback) {
      let that = this;
      let invoice_title = that.goods_list[index].invoice_title;
      let invoice_taxpayer = that.goods_list[index].invoice_taxpayer;
      let invoice_title_type = that.goods_list[index].invoice_title_type;
      let is_default = 0;
      if (!invoice_title) {
        that.$message({
          showClose: true,
          message: "请填写发票抬头",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      } else if (invoice_title_type == 2 && !invoice_taxpayer) {
        that.$message({
          showClose: true,
          message: "请填写税号",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let params = {
        header: invoice_title,
        type: invoice_title_type,
        is_default: is_default,
      };
      if (invoice_title_type == 2) {
        params.taxpayer = invoice_taxpayer;
      }

      that.$api
        .pushInvoice(params)
        .then((res) => {
          if (res.code == 0) {
            that.$set(that.goods_list[index], "invoice_id", res.data.id);
            if (callback) {
              callback();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 计算价格
    computePrice() {
      let that = this;
      let data = that.data;
      let mch_list = that.goods_list;
      let integral_status = that.integral_status; //积分状态
      let balance_status = that.balance_status; //余额状态
      let user_balance = 0;
      let all_express_price = 0;
      if (that.user_info) {
        user_balance = that.user_info.money;
      }
      let order_total_price = 0;
      let order_total_goods_price = 0;
      let order_goods_num = 0;
      for (let i in mch_list) {
        let store_price = 0; //店铺总金额
        let store_goods_price = 0; //店铺商品总金额
        let parts_id = null;
        for (let j in mch_list[i].goods_list) {
          if (mch_list[i].goods_list[j].parts_id > 0) {
            if (parts_id != mch_list[i].goods_list[j].parts_id) {
              parts_id = mch_list[i].goods_list[j].parts_id;
              store_price += Number(mch_list[i].goods_list[j].parts_price);
              store_goods_price += Number(
                mch_list[i].goods_list[j].parts_price
              );
            }
          } else {
            if (mch_list[i].goods_list[j].is_level) {
              store_price += Number(mch_list[i].goods_list[j].level_price);
              store_goods_price += Number(
                mch_list[i].goods_list[j].level_price
              );
            } else {
              store_price += Number(mch_list[i].goods_list[j].price);
              store_goods_price += Number(mch_list[i].goods_list[j].price);
            }
          }
          order_goods_num += mch_list[i].goods_list[j].num;
        }
        // 快递配送
        if (mch_list[i].offline == 0 && that.address_id) {
          store_price += Number(mch_list[i].express_price);
          all_express_price += Number(mch_list[i].express_price);
        }
        // console.log(mch_list);
        // // 优惠券抵扣
        if (this.radio) {
          for (var j = 0; j < mch_list[i].coupon_list.length; j++) {
            if (this.radio == mch_list[i].coupon_list[j].user_coupon_id) {
              mch_list[i].picker_coupon = mch_list[i].coupon_list[j];
              store_goods_price -= Number(mch_list[i].coupon_list[j].sub_price);
              store_price -= Number(mch_list[i].coupon_list[j].sub_price);
            }
          }

          //     mch_list[i].picker_coupon.use_price = store_price; //优惠券使用的金额
          //     store_price = 0;
          //   } else {
          //     mch_list[i].picker_coupon.use_price =
          //       mch_list[i].picker_coupon.sub_price; //优惠券使用的金额
          //     store_price -= Number(mch_list[i].picker_coupon.sub_price);
          //   }
        }
        mch_list[i].total_price = store_price.toFixed(2);
        order_total_price += Number(store_price);
        order_total_goods_price += Number(store_goods_price);
      }
      // 积分抵扣
      let integral_is_show = true;
      if (order_total_price > 0) {
        if (integral_status == 1) {
          if (order_total_price >= Number(data.integral.forehead)) {
            order_total_price -= Number(data.integral.forehead);
          } else {
            order_total_price = 0;
          }
        }
      } else {
        integral_is_show = false;
        that.integral_status = 0;
      }
      // 消费卡
      let expense_card_is_show = true;
      let expense_card = that.check_expense_card; //消费卡使用金额
      let platform_index = that.platform_index;
      let use_expense_card_price = 0;
      let platform_price = 0;
      if (platform_index >= 0) {
        platform_price = mch_list[that.platform_index].total_price;
        if (platform_price > 0) {
          if (integral_status == 1) {
            if (platform_price >= Number(data.integral.forehead)) {
              platform_price -= Number(data.integral.forehead);
            } else {
              platform_price = 0;
            }
          }
          if (expense_card) {
            if (platform_price >= Number(expense_card.sur_price)) {
              use_expense_card_price = Number(expense_card.sur_price);
            } else {
              use_expense_card_price = Number(platform_price);
            }
            order_total_price -= use_expense_card_price;
          }
        } else {
          expense_card_is_show = false;
        }
      }
      // 余额
      let balance_is_show = true;
      let balance_price = Number(user_balance);
      if (order_total_price > 0) {
        if (balance_status == 1) {
          if (order_total_price >= Number(user_balance)) {
            order_total_price -= Number(user_balance);
            balance_price = 0;
          } else {
            balance_price -= order_total_price;
            order_total_price = 0;
          }
        }
      } else {
        balance_is_show = false;
        that.balance_status = 0;
      }
      that.goods_list = mch_list;
      that.integral_is_show = integral_is_show;
      that.expense_card_is_show = expense_card_is_show;
      that.balance_is_show = balance_is_show;
      that.balance_price = balance_price.toFixed(2);
      that.use_expense_card_price = use_expense_card_price.toFixed(2);
      that.order_total_price = order_total_price.toFixed(2); //应付金额
      that.order_goods_num = order_goods_num; //商品数量
      that.all_express_price = all_express_price; //总运费
      that.order_total_goods_price = order_total_goods_price; //商品总金额（裸价）
    },
    // 提交订单
    payNow() {
      let that = this;
      let goods_list = that.goods_list;
      let vr_type = that.vr_type; //商品类型
      let mailbox_val = that.mailbox_val.trim(); //邮箱
      let balance_status = that.balance_status; //余额状态
      let integral_status = that.integral_status; //积分状态
      let payment_type = that.payment_type; //选中的支付方式
      if (integral_status == 0) {
        integral_status = 2; // 1：是使用积分，2： 是不使用
      }
      let use_consumer = that.use_consumer;
      let payment = JSON.stringify([payment_type]);

      // 验证收货地址是否选择
      for (let i in goods_list) {
        if (
          goods_list.length == 1 &&
          goods_list[i].mch_id == 0 &&
          goods_list[i].offline == 1
        ) {
          // console.log('平台商品选择的自提');
        } else {
          if (!that.address_id) {
            that.$message({
              showClose: true,
              message: "请添加收货地址",
              type: "warning",
              offset: 200,
              duration: 1000,
            });
            return false;
          }
        }
        if (goods_list[i].is_show_invoice && !goods_list[i].invoice_id) {
          that.addInvoice(i, function () {
            that.payNow();
          });
          return false;
        }
      }
      if (payment_type == -1) {
        that.$message({
          showClose: true,
          message: "请选择支付方式",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if (payment_type == 0 || payment_type == 1 || payment_type == 5) {
        //0 支付宝   1 微信     5 银联支付
        if (balance_status == 1) {
          if (that.order_total_price > 0) {
            payment = JSON.stringify([payment_type + "", "3"]);
          } else {
            payment = JSON.stringify(["3"]);
          }
        }
      } else if (payment_type == 2) {
        //货到付款
        payment = JSON.stringify(["2"]);
      } else if (payment_type == 3) {
        if (that.order_total_price > 0) {
          that.$message({
            showClose: true,
            message: "余额不足",
            type: "warning",
            offset: 200,
            duration: 1000,
          });
          return false;
        }
      }
      let params = {
        mch_list: JSON.stringify(goods_list),
        use_integral: integral_status,
        payment: payment,
      };
      // console.log(params);
      // return false;
      if (that.address_id) {
        params.address_id = that.address_id;
      }
      // 后期需要修改
      /* if (use_consumer) {
					params.use_consumer = use_consumer;
				} */
      if (vr_type && vr_type != 0) {
        let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (reg.test(mailbox_val)) {
          params.send_email = mailbox_val;
        } else {
          that.$message({
            showClose: true,
            message: "邮箱账号格式错误",
            type: "warning",
            offset: 200,
            duration: 1000,
          });
          return false;
        }
      }
      // console.log(JSON.stringify(goods_list))
      // console.log(params);
      // return false;
      that.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      // 是否为宝付支付
      if (that.alipayIsZl == 2 || that.wechatIsZl == 2) {
        params.is_baofu = 1;
      } else {
        params.is_baofu = 2;
      }

      that.$api
        .newSubmit(params)
        .then((res) => {
          if (res.code == 0) {
            that.payData(res.data);
          }
        })
        .catch((error) => {
          that.loading.close();
          this.common.message(this, error);
        });
    },
    // 支付
    payData(obj) {
      let that = this;
      let params = {
        pay_type: obj.pay_type,
      };
      let payurl = window.location.href;
      let payurls = payurl.split("#")[0] + "#/ttshop_usermyorder";
      // let payurls = "http://demo.oeob.net/#/ttshop_usermyorder";
      if (that.payment_type == 0 || that.payment_type == 5) {
        //支付宝  || 银联
        if (that.balance_status == 1) {
          if (that.order_total_price > 0) {
            params.return_url = payurls;
          }
        } else {
          params.return_url = payurls;
        }
      }
      if (obj.order_id_list) {
        params.order_id_list = JSON.stringify(obj.order_id_list);
      } else if (obj.order_id) {
        params.order_id = obj.order_id;
      }

      if (params.pay_type == "ALIPAY") {
        params.alipay_is_zl = that.alipayIsZl;
      }
      if (params.pay_type == "WECHAT_PAY") {
        params.wetchat_is_zl = that.wechatIsZl;
      }

      let datapage = {
        // 埋点
        web_url: this.$route.path,
        type: 1,
        scene: "",
        order_id: params.order_id_list
          ? JSON.parse(params.order_id_list)[0]
          : params.order_id,
        order_type: 1,
      };

      let paramsObj = this.common.publicPage(this, datapage);
      this.$api.statistics_data(paramsObj).then((res) => {
        console.log(res);
      });
      that.$api
        .orderPay(params)
        .then((res) => {
          that.loading.close();
          if (res.code == 0) {
            if (
              (res.data == "" && that.payment_type == 2) ||
              (res.data == "" && that.order_total_price == 0)
            ) {
              that.$message({
                showClose: true,
                message: "购买成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              setTimeout(() => {
                that.$router.replace({
                  path: "/ttshop_usermyorder",
                  query: {},
                });
              }, 800);
            } else {
              console.log(that.payment_type, "支付方式-------------");
              if (that.payment_type == 0) {
                that.payType = "支付宝支付";
              } else {
                that.payType = "微信支付";
              }
              if (
                (that.payment_type == 0 && that.alipayIsZl == 2) ||
                (that.payment_type == 1 && that.wechatIsZl == 2)
              ) {
                that.baofu_pay_cont_type = true;
                that.order_status_query = setInterval(() => {
                  that.baofuOrderStatus(
                    params.order_id ? params.order_id : params.order_id_list
                  );
                }, 5000);
                that.baofu_pay_code_url = res.code_url;
              } else {
                if (that.payment_type == 0 || that.payment_type == 5) {
                  //支付宝 || 银联
                  window.sessionStorage.setItem("alipay_type", true);
                  const div = document.createElement("div");
                  div.innerHTML = res.data;
                  document.body.appendChild(div);
                  document.forms[0].submit();
                } else {
                  that.pay_cont_type = true;
                  that.order_status_query = setInterval(() => {
                    that.orderStatus(res.res.order_no);
                  }, 5000);
                  let url = Base64.decode(res.res.code_url);
                  setTimeout(function () {
                    that.qrcodeScan(url);
                  }, 100);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.common.message(this, error);
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.pay_cont_type = false;
          that.baofu_pay_cont_type = false;
          clearInterval(that.order_status_query);
          that.$router.replace({
            path: "/ttshop_usermyorder",
            query: {},
          });
        })
        .catch(() => {
          // console.log('取消')
        });
    },
    // 宝付订单状态查询
    baofuOrderStatus(order) {
      let that = this;
      let params = {
        order_id: order,
        type: 1,
      };
      this.$api
        .baofuOrderStatus(params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data.is_pay == 1) {
              clearInterval(that.order_status_query);
              that.$message({
                type: "success",
                message: "订单支付成功",
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              setTimeout(() => {
                that.$router.replace({
                  path: "/ttshop_usermyorder",
                  query: {},
                });
              }, 800);
              that.baofu_pay_cont_type = false;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //订单状态
    orderStatus(order) {
      let that = this;
      let params = {
        order_no: "order_" + order,
      };
      this.$api
        .orderStatus(params)
        .then((res) => {
          if (res.code == 0) {
            clearInterval(that.order_status_query);
            that.$message({
              type: "success",
              message: "订单支付成功",
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            setTimeout(() => {
              that.$router.replace({
                path: "/ttshop_usermyorder",
                query: {},
              });
            }, 800);
            that.pay_cont_type = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.content {
  padding-bottom: 72px;
}

.pay_active {
  border-color: #ff0e25 !important;
}

.address_active {
  background-image: url(../../assets/images/address_yes.png) !important;

  .top-city {
    color: #333333 !important;
  }

  .top-name {
    color: #333333 !important;
  }
}

// 发票选择样式
.invoice_active {
  border-color: #ff0e25 !important;
  background: #fafafa !important;
}

// 配送方式选择样式
.send_active {
  border-color: #ff0e25 !important;

  div {
    color: #ff0e25 !important;
  }
}

//优惠券选择样式
.coupon_active {
  border-top: 2px solid #ff3259 !important;
  border-bottom: 0 !important;
}

// logo
.search {
  height: 112px;
  background-color: #fff;
  width: 100%;
  border-bottom: 1px solid #ebebeb;

  .search-box {
    height: 112px;

    .logo {
      a {
        display: block;
        width: 187px;
        height: 55px;

        .logo-img {
          width: auto;
          height: auto;
          object-fit: fill;
          display: block;
          margin: 0 auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .logo-line {
        width: 1px;
        height: 55px;
        background: #ebebeb;
        margin-left: 24px;
        margin-right: 20px;
      }

      .shopconsed {
        width: 140px;
        font-size: 20px;
        color: #666666;
        margin-left: 18px;
      }
    }

    .search-c {
      margin-left: auto;

      .search-item {
        color: #999999;

        .search-num {
          width: 24px;
          height: 24px;
          background: #ebebeb;
          border-radius: 24px;
          color: #999999;
          font-size: 14px;
          margin-right: 4px;
        }

        .search-num-active {
          color: #fff;
          background: #ff9010;
        }
      }

      .search-item-active {
        color: #ff9010;
      }

      .search-line {
        width: 60px;
        height: 2px;
        background: #ebebeb;
        margin: 0 8px;
      }

      .search-line-active {
        background: #ff9010;
      }
    }
  }
}

// 地址
.address {
  border-bottom: 1px solid #e6e6e6;

  .address-top {
    height: 59px;
    font-size: 16px;
  }

  .address-list {
    .address-item {
      cursor: pointer;
      width: 274px;
      height: 126px;
      background-image: url(../../assets/images/address_no.png);
      background-repeat: no-repeat;
      padding: 19px 16px;
      box-sizing: border-box;
      margin-right: 30px;
      margin-bottom: 32px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .item-top {
        .top-city {
          font-size: 16px;
          font-weight: 600;
          color: #999999;
          margin-right: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .top-name {
          color: #666666;
        }

        .top-btn {
          width: 40px;
          height: 20px;
          background: #ff9010;
          border-radius: 2px;
          color: #fff;
          margin-left: auto;
        }
      }

      .address-conter {
        width: 242px;
        height: 36px;
        font-size: 12px;
        color: #666666;
        line-height: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .address-btn {
        .delete {
          color: #999999;
        }

        .amend {
          color: #0e9cff;
          margin-left: auto;
        }

        .default {
          color: #0e9cff;
          margin-left: 16px;
        }
      }
    }

    .address-add {
      cursor: pointer;
      width: 274px;
      height: 126px;
      background-image: url(../../assets/images/address_no.png);
      background-repeat: no-repeat;
      margin-bottom: 32px;

      .add-img {
        height: 34px;
        width: 34px;
      }

      .add-title {
        color: #999999;
        line-height: 12px;
        margin-top: 8px;
      }
    }
  }
}

// 支付方式
.pay {
  .pay-title {
    height: 72px;
    font-size: 16px;
  }

  .pay-list {
    .pay-item {
      position: relative;
      width: 158px;
      height: 40px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;

      // &:hover{
      //   border-color: #FF0E25;
      // }
      .pay-img {
        height: 24px;
        width: 27px;
        margin-right: 8px;
      }

      .pay-name {
        color: #666666;
        font-size: 16px;
      }

      .pay-select {
        height: 12px;
        width: 12px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }
}

// 商品信息
.submitshop {
  .shop-name {
    height: 40px;
    font-size: 16px;
  }

  .shop-title {
    height: 40px;
    background-color: #fafafa;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .shop-store {
    .shore-name {
      padding: 0 24px;
      box-sizing: border-box;
      height: 48px;
      font-weight: 600;

      .shore-img {
        height: 12px;
        width: 12px;
        margin-left: 4px;
      }
    }

    .store-box {
      background: #ffffff;
      border: 1px solid #ebebeb;
      padding: 0 24px;
      box-sizing: border-box;

      .shop-item {
        padding: 20px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e6e6e6;

        .shop-details {
          .shop-img {
            height: 60px;
            width: 60px;
          }

          .shop-names {
            width: 230px;
            height: 36px;
            color: #666666;
            line-height: 18px;
            margin-left: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }

        .shop-size {
          .shop-size-box {
            width: 100%;

            div {
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .shop-unpic {
          color: #666666;
        }

        .shop-num {
          color: #666666;
        }

        .shop-subtotal {
          font-weight: bold;
        }
      }

      .setmeal-box {
        .setmeal-title {
          margin-top: 20px;

          .setmeal-unpic {
            color: #666666;
          }

          .setmeal-num {
            color: #666666;
          }

          .setmeal-subtotal {
            font-weight: bold;
          }
        }

        .setmeal-list {
          .setmeal-item {
            padding: 20px 0;
            box-sizing: border-box;
            border-bottom: 1px dashed #e6e6e6;

            &:last-child {
              border-bottom: 1px solid #e6e6e6;
            }

            .shop-details {
              .shop-img {
                height: 60px;
                width: 60px;
              }

              .shop-names {
                width: 230px;
                height: 36px;
                color: #666666;
                line-height: 18px;
                margin-left: 16px;
                overflow: hidden;
              }
            }

            .shop-size {
              .shop-size-box {
                div {
                  color: #666666;
                }
              }
            }

            .shop-unpic {
              color: #666666;
            }

            .shop-num {
              color: #666666;
            }

            .shop-subtotal {
              font-weight: bold;
            }
          }
        }
      }

      .shop-rest {
        .rest-top {
          width: 50%;
          border-bottom: 1px dashed #e6e6e6;
          box-sizing: border-box;

          &:nth-child(2n) {
            border-left: 1px dashed #e6e6e6;
          }

          &:nth-child(3) {
            border-bottom: 0;
          }

          &:nth-child(4) {
            border-bottom: 0;
          }

          // 发票
          .invoice {
            padding: 30px 30px 24px 20px;
            box-sizing: border-box;

            .invoice-title {
              height: 32px;
              line-height: 12px;
              margin-left: -20px;
              cursor: pointer;

              .invoice-select {
                height: 12px;
                width: 12px;
                margin-right: 8px;
              }
            }

            .invoice-content {
              // margin: 0 30px 20px 20px;
              background-color: #fafafa;
              padding: 16px;
              box-sizing: border-box;

              .tab-list {
                .tab-item {
                  height: 32px;
                  min-width: 82px;
                  padding: 0 12px;
                  box-sizing: border-box;
                  background: #ffffff;
                  border-radius: 2px;
                  border: 1px solid #ebebeb;
                  margin-right: 8px;
                  position: relative;
                  box-sizing: border-box;
                  cursor: pointer;
                  margin-bottom: 10px;

                  .tab-img {
                    width: 18px;
                    height: 18px;
                    background-color: #fff0f1;
                    color: #ff3259;
                    margin-right: 4px;
                  }

                  .tab-select {
                    height: 12px;
                    width: 12px;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                  }
                }
              }

              .invoice-type {
                margin-top: 10px;

                .invoice-type-name {
                  width: 48px;
                  margin-right: 14px;
                }
              }

              .invoice-radio {
                margin-top: 20px;

                .invoice-type-name {
                  width: 48px;
                  margin-right: 14px;
                }
              }

              .invoice-hearder {
                margin-top: 20px;

                .invoice-type-name {
                  width: 48px;
                  margin-right: 14px;
                }
              }
            }
          }

          //配送
          .send {
            padding: 30px 0 24px 30px;
            box-sizing: border-box;

            .send-title {
              height: 32px;
              line-height: 12px;
              // margin-left: -20px;
            }

            .send-list {
              .send-item {
                height: 32px;
                width: 140px;
                box-sizing: border-box;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #ebebeb;
                margin-right: 8px;
                position: relative;
                box-sizing: border-box;
                cursor: pointer;

                .send-select {
                  height: 12px;
                  width: 12px;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                }
              }
            }

            .send-box {
              padding: 16px;
              box-sizing: border-box;
              background: #fafafa;
              margin-top: 16px;

              .send-box-item {
                + .send-box-item {
                  margin-top: 16px;
                }

                span {
                  margin-left: 20px;
                  color: #0e9cff;
                  cursor: pointer;
                }
              }
            }

            .send-pic {
              margin-top: 20px;
            }
          }

          // 优惠券
          .coupon {
            padding: 30px 30px 24px 20px;
            box-sizing: border-box;

            .coupon-title {
              height: 32px;
              line-height: 12px;
              margin-left: -20px;
              cursor: pointer;

              .coupon-select {
                height: 12px;
                width: 12px;
                margin-right: 8px;
              }
            }

            .coupon-box {
              position: relative;

              .coupon-tab {
                position: relative;
                background: #fff;
                z-index: 10;
                height: 32px;
                width: 216px;

                .tab-item {
                  width: 108px;
                  border: 1px solid #ebebeb;
                  cursor: pointer;

                  &:last-child {
                    border-left: 0;
                  }
                }
              }

              .coupon-list {
                // position: relative;
                margin-top: -1px;
                width: 522px;
                background: #ffffff;
                border: 1px solid #ebebeb;
                padding: 16px 0;
                box-sizing: border-box;
                max-height: 188px;
                overflow-y: scroll;

                .list-item {
                  padding: 10px 15px;
                  box-sizing: border-box;
                  background: #fafafa;
                  cursor: pointer;

                  .item-pic {
                    font-size: 20px;
                    color: #ff3259;
                    font-weight: bold;
                    margin-right: 10px;

                    span {
                      font-size: 12px;
                      color: #ff3259;
                      font-weight: bold;
                    }
                  }

                  + .list-item {
                    margin-top: 8px;
                  }
                }
              }
            }
          }

          .leave {
            padding: 30px 0 24px 30px;
            box-sizing: border-box;

            .leave-title {
              height: 32px;
              line-height: 12px;
            }
          }
        }
      }
    }
  }
}

// 结算信息
.close {
  .close-title {
    height: 64px;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
  }

  .close-box {
    border: 1px solid #ebebeb;
    padding: 24px 0;
    box-sizing: border-box;

    // 积分
    .integral {
      padding-left: 24px;
      box-sizing: border-box;

      .integral-title {
        margin-left: 8px;

        span {
          color: #ff0e25;
        }
      }
    }

    //消费卡
    .expense {
      margin-bottom: 20px;

      .expense-top {
        padding-left: 24px;
        box-sizing: border-box;
        margin-top: 20px;

        .expense-img {
          height: 12px;
          width: 12px;
        }

        .expense-title {
          margin-left: 8px;
        }
      }

      .expense-box {
        position: relative;
        margin-top: 20px;

        .expense-tab {
          position: relative;
          z-index: 10;
          height: 32px;

          // width: 216px;
          .tab-item {
            padding: 0 24px;
            border: 1px solid #ebebeb;
            background: #fff;
            cursor: pointer;
            border-left: 0;
            box-sizing: border-box;
          }
        }

        .expense-list {
          position: relative;
          margin-top: -1px;
          background: #ffffff;
          border: 1px solid #ebebeb;
          border-left: 0;
          border-right: 0;
          padding: 16px 0;
          box-sizing: border-box;

          .list-item {
            padding: 10px 15px;
            box-sizing: border-box;
            background: #fafafa;
            padding-right: 250px;

            .item-pic {
              font-size: 20px;
              color: #ff3259;
              font-weight: bold;

              span {
                font-size: 12px;
                color: #ff3259;
                font-weight: bold;
              }
            }

            + .list-item {
              margin-top: 8px;
            }
          }
        }
      }
    }

    // 总计
    .aggregate {
      margin-top: 32px;
      padding-right: 36px;
      box-sizing: border-box;

      .aggregate-l {
        margin-right: 64px;

        .aggregate-l-item {
          + .aggregate-l-item {
            margin-top: 4px;
          }

          span {
            color: #ff0e25;
          }
        }
      }

      .aggregate-r {
        .aggregate-r-item {
          + .aggregate-r-item {
            margin-top: 4px;
          }
        }
      }
    }
  }
}

// 底部提交
.bottom {
  margin-top: 32px;

  .bottom-pic {
    color: #666666;

    span {
      color: #ff4300;
      font-size: 22px;
    }
  }

  .bottom-address {
    margin-top: 12px;

    span {
      color: #666666;
    }
  }

  .bottom-person {
    span {
      color: #666666;
    }
  }

  .bottom-btn {
    width: 104px;
    height: 40px;
    background: #ff0e25;
    border-radius: 2px;
    color: #fff;
    font-size: 16px;
    margin-top: 12px;
    cursor: pointer;
  }
}

//添加地址弹窗
.address-mask {
  .address-mask-l {
    width: 60px;
    margin-right: 16px;

    .item-title {
      height: 28px;
      line-height: 28px;
      margin-bottom: 20px;
    }
  }

  .address-mask-r {
    .hint {
      height: 20px;
      color: #ff8500;

      .hint-img {
        height: 12px;
        width: 12px;
        margin-right: 8px;
      }
    }

    .default {
      .default-img {
        height: 12px;
        width: 12px;
        margin-right: 4px;
      }
    }

    .address-btn {
      width: 108px;
      height: 32px;
      background: #ff0e25;
      border-radius: 2px;
      color: #fff;
      margin-top: 38px;
    }
  }
}

// 门店弹窗
.shop-mask {
  .flow {
    border-bottom: 1px dashed #cccccc;
    padding-bottom: 11px;
    box-sizing: border-box;

    .flow-item {
      .flow-num {
        width: 16px;
        height: 16px;
        background: #ff8500;
        color: #fff;
        border-radius: 100%;
        margin-right: 11px;
      }
    }

    .flow-img {
      width: 7px;
      height: 11px;
      margin: 0 10px;
    }
  }

  .select-store {
    height: 52px;
    box-sizing: border-box;

    .store-input {
      width: 222px;
      height: 28px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      padding: 0 11px;
      color: #999999;
      margin-left: 7px;
    }

    .store-search {
      width: 60px;
      height: 28px;
      background: #ffdfe2;
      border: 1px solid #ff0e25;
      box-sizing: border-box;
      color: #ff0e25;
      margin-left: 14px;
      cursor: pointer;
    }
  }

  .store-box {
    .store-list {
      height: 316px;
      width: 302px;
      overflow-y: scroll;
      border: 1px solid #ebebeb;
      padding: 0 11px;
      box-sizing: border-box;

      .store-item {
        margin-top: 18px;

        .item-top {
          .item-img {
            height: 14px;
            width: 14px;
          }

          .item-name {
            margin-left: 11px;
          }

          .item-distance {
            margin-left: auto;
          }
        }

        .item-tel {
          line-height: 18px;
          color: #999999;
          padding-left: 25px;
          box-sizing: border-box;
        }

        .item-address {
          padding-left: 25px;
          box-sizing: border-box;
          color: #999999;
          line-height: 18px;
        }
      }
    }

    .map {
      width: 566px;
      height: 316px;
      background: #ccc;
    }
  }

  .store-btn {
    margin-top: 20px;

    .confirm {
      width: 108px;
      height: 32px;
      background: #ff0e25;
      border-radius: 2px;
      color: #fff;
    }

    .cancel {
      width: 108px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      margin-left: 8px;
    }
  }
}

input::-webkit-input-placeholder {
  color: #999999;
}

.address-mask-box {
  .default {
    cursor: pointer;
  }

  .address-btn {
    cursor: pointer;
  }
}

.mailbox-box {
  padding-top: 32px;
  box-sizing: border-box;
  font-size: 16px;

  .title {
    float: left;
    font-size: 16px;
    line-height: 30px;
  }

  input {
    border: 1px solid #ebebeb;
    border-radius: 2px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 30px;
    width: 240px;
  }
}

.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
  .pay_code_url {
    width: 200px;
    height: 200px;
  }
}
</style>
